export default __webpack_public_path__ + "media/images/mail/whatsapp-a9208d25525b289a4d37c8895c6367e0.png";